/**
 * Whether the User-Agent string indicates a known crawler or automated
 * client (googlebot, bingbot, HeadlessChrome, semrush, curl, etc).
 * Used to skip analytics SDKs (Datadog RUM, Mixpanel) for bot sessions —
 * they only add ingestion cost and error noise. Bots spoofing a regular
 * browser UA are not detectable here; Datadog's server-side detection
 * (@device.type:Bot) remains the second layer for those.
 */
// `bot\b` (not bare `bot`): the trailing word boundary keeps real crawler
// suffixes matching (Googlebot/, bingbot;, AdsBot-) while sparing device
// brands where `bot` is followed by a word char — e.g. `CUBOT_X30` ('_' is a
// word char, so no boundary) — from being misclassified as crawlers and
// silently losing their RUM/Mixpanel telemetry.
const BOT_UA_PATTERN =
	/bot\b|crawler|spider|crawling|slurp|duckduckgo|baiduspider|yandex|sogou|exabot|facebookexternalhit|facebot|ia_archiver|mediapartners-google|adsbot|apis-google|lighthouse|headlesschrome|phantomjs|pingdom|gtmetrix|wget|curl|python-urllib|python-requests|java\/|libwww/i;

export function isBotUserAgent(userAgent?: string): boolean {
	const ua =
		userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
	return BOT_UA_PATTERN.test(ua);
}
